import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '../../product/components/molecules/CustomTable'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '../../product/context/alert/alertContext'
import ProductContext from '../../product/context/product/productContext'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import CustomDialog from '../../product/components/organisms/Dialog'
import { v4 as uuidv4 } from 'uuid'

const statusTypes = [
    { value: '0', show: 'Pending' },
    { value: '1', show: 'Approved' },
    { value: '2', show: 'Rejected' },
]

const OfferManage = (props) => {
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)

    const productContext = useContext(ProductContext)

    const {
        all_offers,
        getAllAdminOffers,
        changeOfferStatus,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearAllBidHistory,
    } = productContext

    const history = useHistory()
    const { setAlert } = alertContext

    const data = props.data
    const toggleFullScreenPopup = props.function

    /* Start of Formik Selection Action Function */
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            cart_id: '',
        },
        onSubmit: (values) => {
            if (values.action === 'approve' || values.action === 'reject') {
                const value = values
                setIsLoading(true)
                changeOfferStatus(value)
            }
        },
    })
    /* End of Formik Selection Action Function */

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.cart_id = data
        if (action === 'approve' || action === 'reject') {
            setChangeStatus(true)
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                project_id: {
                    value: 0,
                    type: 'in',
                    field: 'mot.project_id',
                },
                status: {
                    value: '0',
                    type: 'in',
                    field: 'mot.status',
                },
                email: {
                    value: '',
                    type: 'like',
                    field: 'u.email',
                },
                first_name: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name',
                },
                last_name: {
                    value: '',
                    type: 'like',
                    field: 'u.last_name',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllAdminOffers(values)
        },
    })

    useEffect(() => {
        if (all_offers) {
            all_offers.records.map(
                (data, index) =>
                    (data.statusText =
                        data.status === 0
                            ? 'Pending'
                            : data.status === 1
                            ? 'Approved'
                            : 'Rejected')
            )
            let offers = all_offers.records.length ? all_offers.records : []
            offers.map((e) => {
                e.uuid = uuidv4()
            })
            setTableBody(offers)
        }
        setIsLoading(false)
    }, [all_offers])

    const resetFrom = () => {
        formik.setValues({
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                project_id: {
                    value: 0,
                    type: 'in',
                    field: 'mot.project_id',
                },
                status: {
                    value: '0',
                    type: 'in',
                    field: 'mot.status',
                },
                email: {
                    value: '',
                    type: 'like',
                    field: 'u.email',
                },
                first_name: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name',
                },
                last_name: {
                    value: '',
                    type: 'like',
                    field: 'u.last_name',
                },
            },
        })
        formik.handleReset()
        setIsLoading(false)
    }

    const tableActions = []
    if (formik.values.filters.status.value === '0') {
        tableActions.push({
            label: 'Move to Rejected',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'reject',
        })

        tableActions.push({
            label: 'Move to Approved',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'approve',
        })
    }

    useEffect(() => {
        if (data.status === 'makeoffer') {
            setTableBody([])
            setIsLoading(true)
            formik.values.page = 1
            formik.values.searchterm = ''
            formik.values.filters.project_id.value = data.id
            getAllAdminOffers(formik.values)
        } else {
            resetFrom()
        }
    }, [data.id])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        getAllAdminOffers(formik.values)
    }, [formik.values.filters.status.value])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from === 'offerChange' &&
                responseStatusCommuncation.status === 'success'
            ) {
                setIsLoading(false)
                setChangeStatus(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllAdminOffers(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, secondaryID, action) => {
        console.log('action', id, secondaryID, action)
        formikSelection.values.action = action
        formikSelection.values.cart_id = secondaryID
        if (action === 'approve' || action === 'reject') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push(
            {
                buttonType: 'block',
                clickType: 'reject',
                onclick: onClickEdit,
                tooltipTitle: 'Move to Rejected',
            },
            {
                buttonType: 'check_circle',
                clickType: 'approve',
                onclick: onClickEdit,
                tooltipTitle: 'Move to Approved',
            }
        )

        return actionPush
    }

    const tableValues = [
        {
            field: 'users_first_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Name',
        },
        {
            field: 'users_last_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Last Name',
        },
        {
            field: 'users_email',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Email',
        },
        {
            field: 'qty',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Quantity',
        },
        {
            field: 'amount',
            type: 'price',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Proposed Amount',
        },
        {
            field: 'date_added',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Date Added',
        },
        {
            field: 'statusText',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Status',
        },
    ]

    if (formik.values.filters.status.value === '0') {
        tableValues.push({
            field: 'action',
            type: 'button',
            clickID: 'id',
            secondaryClickID: 'cart_id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        })
    }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'first_name',
                filter: true,
            },
            {
                label: 'Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'last_name',
                filter: true,
            },
            {
                label: 'Email',
                placeholder: 'Enter Email',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'email',
                filter: true,
            },
            {
                label: 'Status',
                placeholder: 'Select Offer Status',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                options: statusTypes,
                name: 'status',
                filter: true,
            },
        ],
    }

    return (
        <FullScreenPopup
            modaltitle={`OFFER DETAILS`}
            open={data.status === 'makeoffer' ? data.popup : false}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={all_offers}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllAdminOffers}
                        diff_id={'uuid'}
                    />
                </div>
                <CustomDialog
                    title={'Change invoice status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    <h5>Are you sure you want to change the status</h5>
                    {formikSelection.values.action === 'cancel' &&
                        mapData(reasonForCancelInvoice)}
                    <div className="actionWrapper">
                        <Button
                            id="invoice_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="invoice_confirm"
                                type="submit"
                                label="Confirm"
                            />
                        </form>
                    </div>
                </CustomDialog>
            </div>
        </FullScreenPopup>
    )
}

export default OfferManage
